<div class="rt-card" layout-full-height padding>
  @if (isSelected || (isMouseover && !readOnly())) {
    <rt-checkbox [checked]="isSelected" (valueChange)="select.emit()" />
  }
  <div class="item-icon" layout layout-align-self-start margin-right-small-x>
    <rt-icon
      [size]="'medium'"
      [name]="icon()"
      [colorToken]="'colorIconPrimaryDefault'"
      [hasAutoHeight]="true"
    />
  </div>
  <div class="item-content">
    <div layout layout-align-items-center>
      <rt-heading variant="heading">
        {{ title() }}
      </rt-heading>
    </div>
    <div margin-top-small-xxx>
      {{ description() }}
    </div>
  </div>
</div>
